import { cssVar, Text, Box } from '@cad-arc';
import React from 'react';

// using the same colors used in the Caution ARC tag component but with unit pill sizing
const cautionColors = {
    '--arc-caution-bg-level-one': cssVar('arc.colors.raw.red.550'),
    '--arc-caution-text-level-one': cssVar('arc.colors.raw.white'),
    '--arc-caution-bg-level-two': cssVar('arc.colors.raw.orange.100'),
    '--arc-caution-text-level-two': cssVar('arc.colors.raw.orange.800'),
    '--arc-caution-bg-level-three': cssVar('arc.colors.raw.purple.100'),
    '--arc-caution-text-level-three': cssVar('arc.colors.raw.purple.800'),
    '--arc-tag-default-bg': cssVar('arc.colors.neutral.default'),
    '--arc-tag-default-text': cssVar('arc.colors.text.primary'),
};

type ColorMapping = {
    backgroundColor: string;
    textColor: string;
};

const colorMapping: { [key: number]: ColorMapping } = {
    1: {
        backgroundColor: cautionColors['--arc-caution-bg-level-one'],
        textColor: cautionColors['--arc-caution-text-level-one'],
    },
    2: {
        backgroundColor: cautionColors['--arc-caution-bg-level-two'],
        textColor: cautionColors['--arc-caution-text-level-two'],
    },
    3: {
        backgroundColor: cautionColors['--arc-caution-bg-level-three'],
        textColor: cautionColors['--arc-caution-text-level-three'],
    },
    4: {
        backgroundColor: cautionColors['--arc-tag-default-bg'],
        textColor: cautionColors['--arc-tag-default-text'],
    },
};

type LabelPillProps = {
    text: string;
    priority: number;
    // Add other props here if needed
    [key: string]: any;
};

// properties taken from Unit Pill sizing
const LabelPill: React.FC<LabelPillProps> = ({ text, priority, ...props }) => {
    const { backgroundColor, textColor } = colorMapping[priority] || colorMapping[4];
    return (
        <Box
            display="flex"
            alignItems="center"
            h="21px"
            w="fit-content"
            padding="0px 4px 0px 3px"
            borderRadius="2"
            cursor="default"
            userSelect="none"
            fontFamily="body"
            backgroundColor={backgroundColor}
            fontSize="13px"
            className="unit-pill"
            {...props}
        >
            <Text casing="uppercase" className="unit-pill-text" style={{ color: textColor }}>
                {text}
            </Text>
        </Box>
    );
};

export default LabelPill;
